export default __webpack_public_path__ + "static/media/favpng_nyan-cat-donuts-pusheen-pixel-art.b2d36e1a.png";